import { Component } from "react";
import InputMask from "react-input-mask";
import ComunServicio from "../../../servicios/Comun";
import {
  __DescargarArchivo,
  __MaximoCaracteresIdentificacion,
} from "../../../Utils/Funciones";
import ReactToPrint from "react-to-print";
import RenderizarReporte from "./RenderizarReporte";
import ParametroSolicitudReporteCrediticio from "../../../Contenedores/InformacionCrediticia/ParametroSolicitudReporteCrediticio";
import ServicioInformacionCrediticia from "../../../servicios/InformacionCreditica";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import TipoPersonaDropdown from "../../Comunes/Dropdowns/TiposPersona/TipoPersonaDropdown";

const REPORTE_DEUDOR = "1";
export default class GenerarReporteCrediticio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ListaTiposReporte: [],
      identificacion: "",
      seleccionTipoPersona: "1",
      seleccionTipoReporte: "2",
      seleccionVisualizacion: "mostrar",
      documento: "",
      TipoPersonaFisica: true,
      MaximoCaracteres: 9,
      ReporteHtml: "",
      MostrarResporte: false,
    };

    this._GenerarReporteCrediticio = this._GenerarReporteCrediticio.bind(this);
    this._onSelectTiposPersona = this._onSelectTiposPersona.bind(this);
    this._ObtengaIdentificacion = this._ObtengaIdentificacion.bind(this);
    this._onSeleccionTipoReporte = this._onSeleccionTipoReporte.bind(this);
  }

  async componentDidMount() {
    await this.ObtengaCombobox();
  }

  async ObtengaCombobox() {
    let listaTiposReporte = await ComunServicio.ObtengaTiposReporteCrediticio();
    this.setState({
      ListaTiposReporte: listaTiposReporte,
    });
  }

  async _onSelectTiposPersona(e) {
    let valor = e.target.value;
    let max = await __MaximoCaracteresIdentificacion(valor);

    this.setState({
      MaximoCaracteres: max,
      seleccionTipoPersona: valor,
    });
  }

  async _onSeleccionTipoReporte(e) {
    if (e.target.value === REPORTE_DEUDOR) {
      this.setState({
        seleccionVisualizacion: "mostrar",
      });
    }

    this.setState({
      seleccionTipoReporte: e.target.value,
    });
  }

  async _ObtengaIdentificacion({ target: { value } }) {
    this.setState({
      identificacion: value,
    });
  }

  onVisualizacionChange = (event) => {
    this.setState({
      seleccionVisualizacion: event.target.value,
    });
  };

  async maskbuilder(v) {
    let digitos = !v ? "" : v.replace(/[^\d]/g, "");
    if (digitos.length > this.state.MaximoCaracteres) {
      digitos = v.substring(0, this.state.MaximoCaracteres);
      this.setState({ identificacion: digitos });
    }
    return digitos;
  }

  async _GenerarReporteCrediticio() {
    this.setState({
      MostrarResporte: false,
    });

    const parametro = new ParametroSolicitudReporteCrediticio();
    parametro.Identificacion = this.state.identificacion;
    parametro.TipoPersona = this.state.seleccionTipoPersona;
    parametro.TipoReporte = this.state.seleccionTipoReporte;

    if (this.state.seleccionVisualizacion === "mostrar") {
      await this.generarReporteCrediticioParaMostrar(parametro);
    }

    if (this.state.seleccionVisualizacion === "descargar") {
      await this.generarReporteCrediticioParaDescargar(parametro);
    }
  }

  async generarReporteCrediticioParaMostrar(parametro) {
    const reporte =
      await ServicioInformacionCrediticia.ObtengaReporteCrediticio(parametro);
    if (reporte.esValido) {
      this.setState({
        ReporteHtml: reporte.reporteHtml,
        MostrarResporte: true,
      });
      CerrarNotificador();
    } else {
      Notificar("error", reporte.errores);
    }
  }

  async generarReporteCrediticioParaDescargar(parametro) {
    const reporte =
      await ServicioInformacionCrediticia.ObtengaReporteCrediticioParaDescargar(
        parametro
      );

    if (reporte.esValido) {
      await __DescargarArchivo(reporte.reporteZip, reporte.nombreArchivo);

      CerrarNotificador();
    } else {
      Notificar("error", reporte.errores);
    }
  }

  render() {
    return (
      <div>
        <div className="card shadow mb-4">
          <div className="card-header">
            <h6 className="m-0 font-weight-bold text-primary">
              Datos de Consulta
            </h6>
          </div>
          <div className="card-body">
            <div className="form-row">
              <div className="form-group col-md-4">
                <label htmlFor="TiposPersona" className="col-form-label">
                  {" "}
                  Tipo Persona
                </label>
                <TipoPersonaDropdown
                  id="TiposPersona"
                  value={this.state.seleccionTipoPersona}
                  onChange={(e) => this._onSelectTiposPersona(e)}
                />
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="Identificacion" className="col-form-label">
                  Identificación
                </label>
                <InputMask
                  mask={this.maskbuilder(this.state.identificacion)}
                  maskChar=""
                  value={this.state.identificacion}
                  id="Identificacion"
                  className="form-control"
                  onChange={this._ObtengaIdentificacion}
                />
              </div>

              <div className="form-group col-md-4">
                <label htmlFor="TiposReporte" className="col-form-label">
                  {" "}
                  Tipo Reporte
                </label>
                <select
                  id="TiposReporte"
                  className="form-control"
                  value={this.state.seleccionTipoReporte}
                  onChange={(e) => this._onSeleccionTipoReporte(e)}
                >
                  {this.state.ListaTiposReporte.map((item) => (
                    <option key={item.descripcion} value={item.codigo}>
                      {item.descripcion}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {this.state.seleccionTipoReporte !== REPORTE_DEUDOR ? (
              <div className="form-row">
                <div className="form-group col-md-12">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="visualizacion"
                      id="mostrar"
                      value="mostrar"
                      checked={this.state.seleccionVisualizacion === "mostrar"}
                      onChange={this.onVisualizacionChange}
                    />
                    <label className="form-check-label" htmlFor="mostrar">
                      Mostrar en pantalla
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="visualizacion"
                      id="descargar"
                      value="descargar"
                      checked={
                        this.state.seleccionVisualizacion === "descargar"
                      }
                      onChange={this.onVisualizacionChange}
                    />
                    <label className="form-check-label" htmlFor="descargar">
                      Descargar directamente
                    </label>
                  </div>
                </div>
              </div>
            ) : null}
            <button
              type="button"
              id="btn_Generar"
              className="btn btn-primary btn-icon-split"
              onClick={this._GenerarReporteCrediticio}
            >
              <span className="icon text-white-50">
                <i className="far fa-arrow-alt-circle-right"></i>
              </span>
              <span className="text">Generar Reporte</span>
            </button>
          </div>
        </div>
        {this.state.MostrarResporte === true ? (
          <div className="card shadow mb-4">
            <div className="card-header sticky-top">
              <div className="text-right">
                <ReactToPrint
                  trigger={() => {
                    return (
                      <button className="btn btn-primary btn-icon-split text-center">
                        <span className="icon text-white-50">
                          <i className="fas fa-print"></i>
                        </span>
                        <span className="text">Imprimir</span>
                      </button>
                    );
                  }}
                  content={() => this.componentRef}
                />
              </div>
            </div>
            <div className="card-body overflow-auto">
              <RenderizarReporte
                ReporteHtml={this.state.ReporteHtml}
                ref={(el) => (this.componentRef = el)}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
